import { render, staticRenderFns } from "./OfferFileDropZone.vue?vue&type=template&id=6c205255&scoped=true"
import script from "./OfferFileDropZone.vue?vue&type=script&lang=js"
export * from "./OfferFileDropZone.vue?vue&type=script&lang=js"
import style0 from "./OfferFileDropZone.vue?vue&type=style&index=0&id=6c205255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c205255",
  null
  
)

export default component.exports